// Module
var code = "<p>To learn more about SCRA benefits, contact your Judge Advocate General&#39;s Corps Office.</p> <h2 class=\"interiorSectionHeading\">Reduced Payment and Loan Forgiveness Options</h2> <p>There are options available to lower your monthly payment amount! You may even be eligible for partial or complete loan forgiveness.</p> ";
// Exports
export default code;